<template>
  <div class="main-flex-container">
    <CabinetHeader v-if="isAuthorized"></CabinetHeader>
    <header v-else>
      <!-----------------ШАПКА МОБ ВЕРСИЯ--------------------------->
      <div class="d-block d-lg-none text-center">
        <div class="row mx-0">
          <div class="col-12">
            <div class="row">
              <div class="shadow col-12 pb-1">
                <div class="row">
                  <div class="col-2 ml-md-n4 mt-2">
                    <button class="btn_menu">
                      <i class="fa fa-bars fa-4x px-2"></i>
                    </button>
                  </div>
                  <div class="col-9 mt-1">
                    <img src="../assets/images/Logo_4P.png" class="mob_img" >
                  </div>
                </div>
              </div>

              <div class="col-6">
                <div class="d-flex justify-content-center">
                  <img src="../assets/images/Icon_car 1.png">
                  <div class="ml-3 mt-3">
                    <div class="ml-2 h6 support">Поддержка</div>
                    <div>
                      <button class="ml-2 pb-1 btn_call_back">
                        <span class="call_back">Перезвонить</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div class="mt-3">
                  <div>
                    <img src="@/assets/images/Vector1.png">
                    <a href="tel:+7 495 998 32 32" class="tl"> +7 495 998 32 32</a>
                  </div>
                  <div class="mt-1">
                    <img src="@/assets/images/Vector (2).png">
                    <a href="mailto:info@callisto-pro.ru" class="ml"> info@callisto-pro.ru</a>
                  </div>
                </div>
              </div>
            </div>
            <hr class="mt-0 d-lg-none line">
          </div>
          <div class="col-12">
            <div class="row">
              <div class="col-6 ">
                <div><button class="btn_proposal_to_the_doctor mob_btn">
                  <span class="proposal_to_the_doctor mob_text_btn"> Предложение для врача </span>
                </button></div>
              </div>

              <div class="col-6">
                <div><button class="btn_sign_up_for_training mob_btn">
                  <span class="sign_up_for_training mob_text_btn"> Записаться на обучение </span>
                </button></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-----------------ШАПКА КОМП ВЕРСИЯ--------------------------->
      <div class="row d-none d-lg-flex mx-0">
        <div class="col-12">
          <div class="row">
            <div class="col-lg-4 col-xl-4 mt-2 col-md-12 ">
              <router-link to="/"><img src="@/assets/images/Logo_Kalisto.svg" ></router-link>
            </div>
            <div class="col-lg-6 col-xl-6 mt-2 col-md-6 text-center ">
              <img src="@/assets/images/header_ai.svg">
              <span class="pl-2" style="font-size: 18px; color: #2fb671; font-weight: 600;">Используем искусственный интеллект в оценке лабораторных исследований.</span>

            </div>
            <!--            <div class="col-lg-2 col-xl-2 mt-2 col-md-6 text-center header__buttons">-->
            <!--              <button class="btn_sign_up_for_training">-->
            <!--                <span class="sign_up_for_training"> Записаться на обучение </span>-->
            <!--              </button>-->
            <!--            </div>-->
            <!--            <div class="col-lg-2 col-xl-2 d-flex col-md-6 justify-content-center ">-->
            <!--              <img src="../assets/images/Icon_car 1.png" >-->
            <!--              <div class="ml-3 mt-3">-->
            <!--                <div class="ml-2 h6 support"> Поддержка </div>-->
            <!--                <div>-->
            <!--                  <button class="ml-2 pb-1 btn_call_back">-->
            <!--                    <span class="call_back">Перезвонить</span>-->
            <!--                  </button>-->
            <!--                </div>-->
            <!--              </div>-->
            <!--            </div>-->
            <div class="col-lg-2 col-xl-2 my-2 d-none text-right d-md-block col-md-6 ">
              <div class="row">
                <div class="px-0 col col-lg-4 col-md-3 col-sm-2 text-right">
                  <img src="@/assets/images/Vector1.png">&nbsp;
                </div>
                <div class="px-0 col text-left">
                  <a href="tel:+7 495 998 32 32" class="tl"> +7 495 998 32 32</a>
                </div>
              </div>
              <div class="row">
                <div class="px-0 mt-1 col col-lg-4 col-md-3 col-sm-2 text-right">
                  <img src="@/assets/images/Vector (2).png">&nbsp;
                </div>
                <div class="px-0 mt-1 col text-left">
                  <a href="mailto:info@callisto-pro.ru" class="ml"> info@callisto-pro.ru</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--      <hr class="mt-lg-0 mb-0 mb-lg-3 line_2">-->
    </header>
    <img src="@/assets/images/BAnner2.png" class="w-100" style="height: 37px!important;">
    <div class="main-content">



      <router-view/>

    </div>
    <footer>
      <div class="row mx-0 backgrround">
        <div class="col-md-6"><p class="foot">© 2021-2023 Каллисто. Все права защищены</p></div>
        <div class="col-md-2 text-md-center"><p class="foot"><a href="#" class="foot"> Лицензиии и сертификаты</a></p></div><div class="d-none d-md-block line_small">|</div>
        <div class="col-md-2 text-md-center"><p class="foot"><a href="#" class="foot"> Условия конфиденциальности</a></p></div><div class="d-none d-md-block line_small">|</div>
        <div class="col-md text-md-center"><p class="foot"><a href="#"  class="foot"> Контактная информация </a></p></div>
      </div>
    </footer>
  </div>
</template>

<script>

import CabinetHeader from "@/components/CabinetHeader";


export default {
  name: "ContentPageLayout",
  components: { CabinetHeader },
  computed: {
    isAuthorized: {
      get() {
        return this.$store.getters.isAuthorized
      },
      set(value) {
        this.$store.commit('updateIsAuthorized', value)
      }
    },
    role: {
      get() {
        return this.$store.getters.role
      },
      set(value) {
        this.$store.commit('updateRole', value)
      }
    },
    rolename: {
      get() {
        return this.$store.getters.rolename
      },
      set(value) {
        this.$store.commit('updateRolename', value)
      }
    },
    username: {
      get() {
        return this.$store.getters.username
      },
      set(value) {
        this.$store.commit('updateUsername', value)
      }
    },
    userId: {
      get() {
        return this.$store.getters.userId
      },
      set(value) {
        this.$store.commit('updateUserId', value)
      }
    },
    activationDaysLeftCount: {
      get() {
        return this.$store.getters.activationDaysLeftCount
      },
      set(value) {
        this.$store.commit('updateActivationDaysLeftCount', value)
      }
    },
    reportDetailedBlock: {
      get() {
        return this.$store.getters.reportDetailedBlock
      },
      set(value) {
        this.$store.commit('updateReportDetailedBlock', value)
      }
    },
    reportGeneralBlock: {
      get() {
        return this.$store.getters.reportGeneralBlock
      },
      set(value) {
        this.$store.commit('updateReportGeneralBlock', value)
      }
    },
    reportConciseBlock: {
      get() {
        return this.$store.getters.reportConciseBlock
      },
      set(value) {
        this.$store.commit('updateReportConciseBlock', value)
      }
    },
    reportPatientBlock: {
      get() {
        return this.$store.getters.reportPatientBlock
      },
      set(value) {
        this.$store.commit('updateReportPatientBlock', value)
      }
    },
    reportGraphicBlock: {
      get() {
        return this.$store.getters.reportGraphicBlock
      },
      set(value) {
        this.$store.commit('updateReportGraphicBlock', value)
      }
    },
    permission: {
      get() {
        return this.$store.getters.permission
      },
      set(value) {
        this.$store.commit('updatePermission', value)
      }
    }
  },
}
</script>

<style scoped>

</style>